import { Icon } from '@iconify/react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import androidFilled from '@iconify/icons-ant-design/file-done-outlined';
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { Card, Typography } from '@material-ui/core';
import { fShortenNumber } from '../../../utils/formatNumber';
import { baseUrl } from '../../../utils/constants';

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.primary.darker,
  backgroundColor: theme.palette.primary.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
    theme.palette.primary.dark,
    0.24
  )} 100%)`
}));

const TOTAL = 0;

export default function AppWeeklySales() {
  const navigate = useNavigate();
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [dashSum, setDashSum] = useState({
    totalActive: 0,
    newMembers: 0,
    paymentsThisMonth: 0.0,
    failedDebitOrders: 0.0
  });

  useEffect(() => {
    getDashBoardSummaries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDashBoardSummaries = () => {
    fetch(`${baseUrl}/api/client/getDashBoardSummaries`)
      .then((res) => res.json())
      .then(
        (result) => {
          setDashSum(result.result);
        },
        (error) => {
          notifyPopup(`Error in getDashBoardSummaries!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <RootStyle>
      <IconWrapperStyle>
        <Icon
          icon={androidFilled}
          width={24}
          height={24}
          onClick={() => navigate('/clientportfolio/webapplications')}
        />
      </IconWrapperStyle>
      <Typography variant="h3">{fShortenNumber(dashSum.newMembers)}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        New Members
      </Typography>
    </RootStyle>
  );
}
